const TEST_PROCESS_STEP_START = 'inicio';
const TEST_PROCESS_STEP_STEP_1 = 'paso_1';
const TEST_PROCESS_STEP_STEP_2 = 'paso_2';
const TEST_PROCESS_STEP_STEP_3 = 'paso_3';
const TEST_PROCESS_STEP_STEP_4 = 'paso_4';
const TEST_PROCESS_STEP_STEP_5 = 'paso_5';
const TEST_PROCESS_STEP_STEP_6 = 'paso_6';
const TEST_PROCESS_STEP_STEP_7 = 'paso_7';
const TEST_PROCESS_STEP_STEP_8 = 'paso_8';
const TEST_PROCESS_STEP_STEP_9 = 'paso_9';
const TEST_PROCESS_STEP_STEP_10 = 'paso_10';
const TEST_PROCESS_STEP_SUCCESS = 'exito';
const TEST_PROCESS_STEP_ERROR = 'error';

const PROCESS_TYPE_ROBO = 'proc-robo-';
const PROCESS_TYPE_ROBO_TI = PROCESS_TYPE_ROBO + 'test-idoneidad';
const PROCESS_TYPE_GBI = 'proc-gbi-';
const PROCESS_TYPE_GBI_TI = PROCESS_TYPE_GBI + 'test-idoneidad';
const PROCESS_TYPE_ONBOARDING = 'onboarding';

export default {
    TEST_PROCESS_STEP_START,
    TEST_PROCESS_STEP_STEP_1,
    TEST_PROCESS_STEP_STEP_2,
    TEST_PROCESS_STEP_STEP_3,
    TEST_PROCESS_STEP_STEP_4,
    TEST_PROCESS_STEP_STEP_5,
    TEST_PROCESS_STEP_STEP_6,
    TEST_PROCESS_STEP_STEP_7,
    TEST_PROCESS_STEP_STEP_8,
    TEST_PROCESS_STEP_STEP_9,
    TEST_PROCESS_STEP_STEP_10,
    TEST_PROCESS_STEP_SUCCESS,
    TEST_PROCESS_STEP_ERROR,
    PROCESS_TYPE_ROBO,
    PROCESS_TYPE_ROBO_TI,
    PROCESS_TYPE_GBI,
    PROCESS_TYPE_GBI_TI,
    PROCESS_TYPE_ONBOARDING,
};
